import EquipmentFeature from './EquipmentFeature';

export default EquipmentFeature;
